// axios
import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL_INVITE || "http://localhost:3030";

export default axios.create({
  baseURL: `${API_URL}`,
  // You can add your headers here
});
